import { Lightning } from '@lightningjs/sdk'

import { transparent } from '../../constants/colors'
import { createMenuItems, toMenuItemRef } from '../../utils/settingsUtils'
import ListMenuItem from './SettingsMenuItem'

export default class SettingsMenu extends Lightning.Component {
  private _currentEl = 0

  static _template() {
    return {
      w: (w) => w,
      rect: true,
      color: transparent,
      collision: true,
      flex: {
        direction: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      },
    }
  }

  get currentEl() {
    return this._currentEl
  }

  set currentEl(v: number) {
    this._currentEl = v
  }

  get totalEl() {
    return this.children.length
  }

  get currentChild() {
    return this.getChild(this._currentEl)
  }

  get firstChild() {
    return this.getChild(0)
  }

  get lastChild() {
    return this.getChild(this.totalEl - 1)
  }

  _init() {
    this.patch({ children: createMenuItems() })
  }

  _getFocused() {
    return this.currentChild
  }

  _handleUp() {
    if (this._currentEl > 0) {
      this._currentEl--
    }
  }

  _handleDown() {
    if (this._currentEl < this.totalEl - 1) {
      this._currentEl++
    }
  }

  getChild(index: number) {
    return this.childList.getByRef(toMenuItemRef(index)) as ListMenuItem
  }

  $updateFocusByHover({ menuItemId }) {
    this._currentEl = menuItemId
    this._refocus()
  }
}
